import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface RecordLinkIconProps {
  recordType: 'party' | 'sales-invoice' | 'purchase-invoice';
  recordId: number;
  className?: string;
  size?: 'sm' | 'default';
}

export const RecordLinkIcon: React.FC<RecordLinkIconProps> = ({ 
  recordType, 
  recordId, 
  className,
  size = 'sm' 
}) => {
  const getRoute = () => {
    switch (recordType) {
      case 'party':
        return `/party/detail/${recordId}`;
      case 'sales-invoice':
        return `/sales-invoices/detail/${recordId}`;
      case 'purchase-invoice':
        return `/purchase-invoices/detail/${recordId}`;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling
    window.open(getRoute(), '_blank');
  };

  const iconSize = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5';
  const buttonSize = size === 'sm' ? 'h-4 w-4' : 'h-6 w-6';

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleClick}
      className={cn(
        buttonSize,
        "inline-flex ml-1 text-muted-foreground hover:text-foreground p-0",
        className
      )}
      title="Open in new tab"
    >
      <ExternalLink className={iconSize} />
    </Button>
  );
};